/**
 * La única forma de hablarle al admin-api.
 *
 * Vive aparte para que `api.ts` y `api-conocimiento.ts` compartan exactamente
 * el mismo cliente: el token, el manejo de errores y la URL base. Duplicarlo
 * daría dos formas de fallar y una sola de arreglarlas.
 */

const BASE = (import.meta.env.VITE_API_URL as string | undefined) ?? '/api';

function getToken(): string | null {
  return localStorage.getItem('admin_token');
}

export async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const token = getToken();
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...(init?.headers as Record<string, string>),
  };
  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await fetch(`${BASE}${path}`, { ...init, headers });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    const message = (err as { error: string }).error ?? res.statusText;
    console.error(`API Error ${res.status}: ${message} at ${path}`);
    throw new Error(`${res.status}: ${message}`);
  }
  return res.json() as Promise<T>;
}
